import React, { useEffect, useState } from "react";
import { useDrag, DndProvider, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import performRequest from "../../api/request";
import LoadingPage from "../../Components/layouts/loading";
import { Toast } from "../../CustomComponent/toast";
import Footer from "../../Components/Footer/footer";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import { Form, Formik } from "formik";
import { CreateLeadTrackingInfo } from "../../SchemaInfo/info";
import { CreateLeadTrackingScheama } from "../../Schemas/sales/leads_tracking_schema";
import CustomInput from "../../CustomComponent/custom_input";
import { BsBoxArrowInRight } from "react-icons/bs";
import { useNavigate } from "react-router";
import { getId } from "../../Components/Functions/word.fun";
import { useSelector } from "react-redux";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
// updation
const LeadsTracking = () => {
  const [loading, setLoading] = useState(false);
  const [siInputData, setSIInputData] = useState({
    dateofSI: "",
    distanceFromAirport: "",
    locationLink: "",
    transferProvider: false,
    numberOfSites: "",
    modeOfTransport: "",
    stayRequired: false,
  });
  const [dataId, setDataId] = useState();
  const [data, setData] = useState([]);
  const [leadOwner, setLeadOwner] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [page, setCurrPage] = useState(1);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    leadOwner: "",
    name: "",
  });
  const [isDropdown, setIsDropdown] = useState("");
  const role = useSelector((state) => state.login.user.Role);
  const handelInputChange = (e) => {
    if (e.target.type === "checkbox") {
      setSIInputData({ ...siInputData, [e.target.name]: e.target.checked });
    } else {
      setSIInputData({ ...siInputData, [e.target.name]: e.target.value });
    }
  };
  const handelSubmitPatch = (e) => {
    e.preventDefault();

    performRequest(
      "PATCH",
      `/newleadsTracking/updateleadsTracking/${dataId}`,
      siInputData
    )
      .then((res) => {
        if (res.status === 200) {
          setDataId("");
          document.getElementById("modal-close").click();
          Toast("success", "Lead updated successfully!");
          setRefresh(!refresh);
        } else {
          setDataId("");
          document.getElementById("modal-close").click();
          Toast("error", "Error while updating lead status");
        }
      })
      .catch((err) => {
        setDataId("");
        document.getElementById("modal-close").click();
        CustomErrorResponse(err);
      });
  };
  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/newleadsTracking/getAllLeadsTracking/", page, filters)
    )
      .then((res) => {
        if (res.status === 201) {
          setData(res.data.getAllLeadsTracking);
        } else {
          Toast("error", "Error while getting Lead!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh]);
  const moveLead = (leadId, newStatus) => {
    performRequest("PATCH", `/newleadsTracking/updateleadsTracking/${leadId}`, {
      lead_status: newStatus,
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Lead updated successfully!");
          setData((prevData) => {
            const leadIndex = prevData.findIndex((lead) => lead.id === leadId);
            if (leadIndex !== -1) {
              const newData = [...prevData];
              newData[leadIndex].lead_status = newStatus;
              return newData;
            }
            return prevData;
          });
        } else {
          setRefresh(!refresh);
          Toast("error", "Error while updating lead status");
        }
      })
      .catch((err) => {
        setRefresh(!refresh);
        CustomErrorResponse(err);
      });
  };

  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setLeadOwner(res?.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const handelSubmit = (values, actions) => {
    performRequest("POST", "/newleadsTracking/createleadsTracking", values)
      .then((res) => {
        if (res.status === 201) {
          document.getElementById("model-dismiss").click();
          Toast("success", "project added successfully!");
          setRefresh(!refresh);
        } else {
          document.getElementById("model-dismiss").click();
          Toast("error", "Error while Creating");
        }
      })
      .catch((err) => {
        document.getElementById("model-dismiss").click();
        CustomErrorResponse(err);
      });
  };

  const handleInputChange = (e, props) => {
    let { value } = e.target;
    if (value && value.length >= 4) {
      performRequest("GET", `/quotations/getQuotationsById/${value}`)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.error) {
              setIsDropdown("Quotations Not Found");
              props.setFieldValue("quotationNumber", "");
            } else {
              setIsDropdown(res.data.quotationNumber);
            }
          } else {
            Toast("error", "Error while getting Quotations!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
      setIsDropdown(!isDropdown);
    }
    // Toggle the dropdown state
  };

  if (loading) {
    return <LoadingPage />;
  }

  const statuses = [
    "hot leads",
    "projected si",
    "site inspection schedule",
    "software demo",
    "subsidy & documeents",
    "aif applications",
    "work order",
    "project complete",
    "lost leads (refund)",
  ];

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="card">
          <div className="row g-3 m-2 mb-0">
            <DynamicFilterInput
              label="Start date:"
              value={filters.startdate}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  startdate: e.target.value,
                })
              }
              type="date"
            />
            <DynamicFilterInput
              label="End date:"
              value={filters.enddate}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  enddate: e.target.value,
                })
              }
              type="date"
            />
            <DynamicFilterInput
              label="Search Name"
              value={filters.name}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  name: e.target.value,
                })
              }
              type="text"
              placeholder="Search name..."
            />
            {(role === process.env.REACT_APP_ROLE_ADMIN_S ||
              role === process.env.REACT_APP_ROLE_ADMIN ||
              role === process.env.REACT_APP_ROLE_SALLE_ADMIN) && (
              <DynamicFilterSelect
                label="Search lead owner:"
                value={filters.leadOwner}
                onChange={(e) =>
                  setFilters({ ...filters, leadOwner: e.target.value })
                }
              >
                <option key={-1} value="">
                  All Type
                </option>
                {leadOwner?.map((item) => (
                  <option key={item?.id} value={item?.id}>
                    {item?.userName}
                  </option>
                ))}
              </DynamicFilterSelect>
            )}

            <div className="col-md">
              <div className="d-flex">
                <button
                  onClick={() => setRefresh(!refresh)}
                  style={{
                    height: "28px",
                    marginRight: "5px",
                  }}
                  className="btn btn-primary mt-3"
                >
                  Search
                </button>

                <button
                  onClick={() => {
                    setFilters({
                      startdate: "",
                      enddate: "",
                      leadOwner: "",
                      name: "",
                    });
                    setRefresh(!refresh);
                  }}
                  style={{ height: "28px" }}
                  className="btn btn-primary mt-3"
                >
                  Reset
                </button>
              </div>
            </div>
            <div className="col-md">
              <button
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#modal-team"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M12 5l0 14" />
                  <path d="M5 12l14 0" />
                </svg>
                ADD NEW SEQUENCE
              </button>
            </div>
          </div>
        </div>
        <div style={{ minHeight: "80vh" }}>
          <div className="page-body">
            <DndProvider backend={HTML5Backend}>
              <div className="card">
                <div className="card-body">
                  <div
                    className="grid"
                    style={{
                      maxWidth: "100%",
                      height: "100%",
                      overflowY: "scroll",
                    }}
                  >
                    {statuses.map((status, index) => (
                      <div
                        key={index}
                        className="listName flex"
                        style={{
                          padding: "0em",
                          border: "1px solid #c4c4c4",
                        }}
                      >
                        <Section
                          siInputData={siInputData}
                          setSIInputData={setSIInputData}
                          dataId={dataId}
                          setDataId={setDataId}
                          status={status}
                          data={data}
                          moveLead={moveLead}
                          refresh={refresh}
                          setRefresh={setRefresh}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </DndProvider>
          </div>
        </div>
        <div
          className="modal modal-blur fade"
          id="modal-team"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <Formik
            initialValues={CreateLeadTrackingInfo}
            validationSchema={CreateLeadTrackingScheama}
            onSubmit={handelSubmit}
          >
            {(props) => (
              <Form className="modal-dialog modal-dialog-centered w-lg-100 w-md-100 ">
                <div className="modal-dialog modal-dialog-centered w-100">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Add a new sequence</h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="mb-3 row">
                        <label className="w-25 form-label required col-3">
                          Name
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="name" type="text" />
                          {props.touched.name && props.errors.name && (
                            <p className="text-danger">{props.errors.name}</p>
                          )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3  ">
                          Quotation
                        </label>

                        <div className="w-100 col dropdown">
                          <CustomInput
                            type={"text"}
                            className="form-control"
                            onChange={(e) => {
                              props.setFieldValue(
                                "quatationNumber",
                                e.target.value
                              );
                              handleInputChange(e, props);
                            }}
                            name="quatationNumber"
                          ></CustomInput>

                          {isDropdown && (
                            <span
                              onClick={() => {
                                if (
                                  isDropdown !== "Quotations Not Found" &&
                                  isDropdown !== ""
                                ) {
                                  props.setFieldValue(
                                    "quatationNumber",
                                    isDropdown
                                  );
                                  setIsDropdown("");
                                }
                              }}
                              className="card cursor-pointer"
                            >
                              {isDropdown}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3  ">
                          Project Area (SqM.)
                        </label>

                        <div className="w-100 col dropdown">
                          <CustomInput
                            type={"text"}
                            className="form-control"
                            name="projectArea"
                          ></CustomInput>

                          {props.touched.projectArea &&
                            props.errors.projectArea && (
                              <p className="text-danger">
                                {props.errors.projectArea}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3  ">
                          Project Area (SqM.)
                        </label>

                        <div className="w-100 col dropdown">
                          <CustomInput
                            type={"text"}
                            className="form-control"
                            name="projectArea"
                          ></CustomInput>

                          {isDropdown && (
                            <span
                              onClick={() => {
                                if (
                                  isDropdown !== "Quotations Not Found" &&
                                  isDropdown !== ""
                                ) {
                                  props.setFieldValue(
                                    "quatationNumber",
                                    isDropdown
                                  );
                                  setIsDropdown("");
                                }
                              }}
                              className="card cursor-pointer"
                            >
                              {isDropdown}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3  ">
                          Project Area (SqM.)
                        </label>

                        <div className="w-100 col dropdown">
                          <CustomInput
                            type={"text"}
                            className="form-control"
                            name="projectArea"
                          ></CustomInput>

                          {props.touched.projectArea &&
                            props.errors.projectArea && (
                              <p className="text-danger">
                                {props.errors.projectArea}
                              </p>
                            )}
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <label className="w-25 form-label required col-3">
                          Location
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="siLocation" type="text" />
                          {props.touched.siLocation &&
                            props.errors.siLocation && (
                              <p className="text-danger">
                                {props.errors.siLocation}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label required col-3">
                          Contact No
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="clientContact" type="text" />
                          {props.touched.clientContact &&
                            props.errors.clientContact && (
                              <p className="text-danger">
                                {props.errors.clientContact}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">Email</label>
                        <div className="w-100 col">
                          <CustomInput name="clientEmail" type="text" />
                          {props.touched.clientEmail &&
                            props.errors.clientEmail && (
                              <p className="text-danger">
                                {props.errors.clientEmail}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer bg-transparent">
                      <button
                        type="button"
                        className="btn me-auto disable"
                        data-bs-dismiss="modal"
                        id="model-dismiss"
                      >
                        Close
                      </button>
                      <div className="btn-list justify-content-center">
                        <FormSubmitButton buttonText="Submit" />
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <div
          className="modal modal-blur fade"
          id="modal-team1"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <form
            onSubmit={handelSubmitPatch}
            className="modal-dialog modal-dialog-centered w-lg-100 w-md-100"
          >
            <div className="modal-dialog modal-dialog-centered w-100">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Add SI Details</h5>
                  <span
                    data-bs-toggle="modal"
                    data-bs-target="#modal-team1"
                    id={"open-model"}
                  ></span>
                  <button
                    id={"modal-close"}
                    onClick={() => setDataId("")}
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3 row">
                    <label className="w-25 form-label  col-3">SI date</label>
                    <div className="w-100 col">
                      <input
                        className="form-control"
                        onChange={handelInputChange}
                        value={siInputData.dateofSI}
                        name="dateofSI"
                        type="date"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label  col-3">
                      Mode of transport
                    </label>
                    <div className="w-100 col">
                      <select
                        className="form-control"
                        onChange={handelInputChange}
                        value={siInputData.modeOfTransport}
                        name="modeOfTransport"
                        type="text"
                      >
                        <option value="">Select</option>
                        <option value="By Car">By Car</option>
                        <option value="By Bus">By Bus</option>
                        <option value="By Train">By Train</option>
                        <option value="By Flite">By Flight</option>
                      </select>
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label  col-3">
                      Distance from airport
                    </label>
                    <div className="w-100 col">
                      <input
                        className="form-control"
                        onChange={handelInputChange}
                        value={siInputData.distanceFromAirport}
                        name="distanceFromAirport"
                        type="text"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label  col-3">
                      Location link
                    </label>
                    <div className="w-100 col">
                      <input
                        className="form-control"
                        onChange={handelInputChange}
                        value={siInputData.locationLink}
                        name="locationLink"
                        type="url"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label  col-3">
                      Transfer provided
                    </label>
                    <div className="w-100 col">
                      <input
                        className="orm-check-input"
                        onChange={handelInputChange}
                        checked={siInputData.transferProvider ? true : false}
                        name="transferProvider"
                        type="checkbox"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label  col-3">
                      Stay required
                    </label>
                    <div className="w-100 col">
                      <input
                        className="orm-check-input"
                        onChange={handelInputChange}
                        checked={siInputData.stayRequired ? true : false}
                        name="stayRequired"
                        type="checkbox"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label  col-3">
                      Number Of sites
                    </label>
                    <div className="w-100 col">
                      <input
                        className="form-control"
                        onChange={handelInputChange}
                        value={siInputData.numberOfSites}
                        name="numberOfSites"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer bg-transparent">
                  <button
                    onClick={() => setDataId("")}
                    type="button"
                    className="btn me-auto disable"
                    data-bs-dismiss="modal"
                    id="model-dismiss"
                  >
                    Close
                  </button>
                  <div className="btn-list justify-content-center">
                    <button
                      className="mx-1 btn btn-primary w-100"
                      type="submit"
                      // data-bs-dismiss="modal"
                    >
                      <BsBoxArrowInRight className="fs-2 me-2" />
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <Footer />
      </div>
    </div>
  );
};

const Section = ({
  status,
  data,
  moveLead,
  refresh,
  setRefresh,
  siInputData,
  setSIInputData,
  dataId,
  setDataId,
}) => {
  const [{ isOver }, drop] = useDrop(() => ({
    accept: "lead",
    drop: (item) => moveLead(item.id, status),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));
  useEffect(() => {
    if (dataId) {
      document.getElementById("open-model").click();
    }
  }, [dataId]);

  const filteredData = data?.filter(
    (lead) => lead.lead_status.toLowerCase() === status
  );

  return (
    <div
      key={Date.now()}
      className={` sort-name ${isOver ? "bg-slate-200" : ""}`}
      ref={drop}
      style={{
        cursor: "pointer",
        borderRadius: "0.2em",
        height: "100%",
        boxShadow: "0 0 4px rgba(0, 0, 0, 0.4)",
        width: "18em",
      }}
    >
      <Header status={status} count={filteredData?.length} />

      <div style={{ padding: "0.5rem", minHeight: "100%" }}>
        {filteredData?.map((lead) => (
          <Lead
            siInputData={siInputData}
            setSIInputData={setSIInputData}
            dataId={dataId}
            setDataId={setDataId}
            key={lead.id}
            lead={lead}
            refresh={refresh}
            setRefresh={setRefresh}
          />
        ))}
      </div>
    </div>
  );
};

const Header = ({ status, count }) => {
  let head;
  if (status == "site inspection schedule") {
    head = "SI SCHEDULED";
  } else if (status == "subsidy & documeents") {
    head = "SUBSIDY & DOCS";
  } else {
    head = status?.toUpperCase();
  }

  return (
    <div key={Date.now()}>
      <h3
        style={{
          margin: "0em",
          paddingLeft: "0.5rem",
          background: "#000",
          color: "#fff",
        }}
      >
        {head} [{count}]
      </h3>
    </div>
  );
};
const Lead = ({
  lead,
  refresh,
  setRefresh,
  dataId,
  setDataId,
  siInputData,
  setSIInputData,
}) => {
  const navigate = useNavigate();

  // Get user role and ID from the Redux store
  const userRole = useSelector((state) => state.login.user.Role);
  const userId = useSelector((state) => state.login.user.UserId);

  const [{ isDragging }, drag] = useDrag(() => ({
    type: "lead",
    item: { id: lead.id },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  const formattedDate = new Date(lead.createdAt).toLocaleString();

  const handelDPR = (leadName) => {
    performRequest(
      "GET",
      `/siteInspection/getSiteInspection?page=1&clientName=${leadName}`
    )
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.siteInspectionCount > 0) {
            const lastInspection =
              res?.data?.siteInspectionData[
                res?.data?.siteInspectionData.length - 1
              ];
            let siId = getId(lastInspection?.siNumber);
            navigate(`/client-site-inspection/view/${siId}`);
          } else {
            Toast("error", "Site Inspection Not Found");
          }
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  const isCardEnabled =
    userRole == process.env.REACT_APP_ROLE_ADMIN_S ||
    userRole == process.env.REACT_APP_ROLE_ADMIN ||
    userRole == process.env.REACT_APP_ROLE_SALLE_ADMIN ||
    lead.generetedBy == userId;

  return (
    <div
      ref={drag}
      className={`lead ${isDragging ? "dragging accordion" : "accordion"}`}
      style={{
        pointerEvents: isCardEnabled ? "auto" : "none",
        opacity: isCardEnabled ? 1 : 0.6,
      }}
      id={`faq-${lead?.id}`}
      role="tablist"
      aria-multiselectable="true"
    >
      <div
        className="card accordion-item p-2"
        style={{
          marginTop: "10px",
          background: "#deeadc",
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          borderRadius: "3px",
        }}
      >
        <div className="row">
          <div className="row" role="tab">
            <div className="col-12">
              <button
                className="accordion-button h-0 fw-bold "
                data-bs-toggle="collapse"
                data-bs-target={`#faq-${lead?.id}-1`}
                style={{
                  padding: "4px",
                  paddingLeft: "0.2em",
                  paddingRight: "0.2em",
                }}
              >
                <span
                  style={{
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 1,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {lead?.name?.toUpperCase()}
                </span>
              </button>
            </div>
          </div>

          <div
            id={`faq-${lead?.id}-1`}
            role="tabpanel"
            data-bs-parent={`#faq-${lead?.id}`}
            className="accordion-collapse collapse list-group list-group-flush overflow-hidden col-12"
            style={{
              border: "none",
              padding: "0 0em 0.5em 0.5em",
              marginTop: "8px",
            }}
          >
            {/* <hr className="m-2"></hr> */}
            <div className="col-auto">
              <div className="text-body d-block">
                Location: {lead?.siLocation || "N/A"}
              </div>
              <div className="text-body d-block">
                Contact: {lead?.clientContact || "N/A"}
              </div>
              <div className="text-body d-block">
                Email: {lead?.clientEmail || "N/A"}
              </div>
              <div className="text-body d-block">
                Seq owner: {lead?.userName || "N/A"}
              </div>
              <div className="text-body d-flex">
                Quote:
                {lead?.quatationNumber ? (
                  <a
                    className=" ms-1"
                    href={`/custom-quotation/${getId(lead?.quatationNumber)}`}
                  >
                    {lead?.quatationNumber}
                  </a>
                ) : (
                  " N/A"
                )}
              </div>

              <div className="text-body d-block">
                {`Area (SqM): ${lead?.projectArea || "N/A"}`}
              </div>
              <div className="text-body d-block">
                {`SI date: ${lead?.dateofSI || "N/A"}`}
              </div>
              <div className="text-body d-block">
                {`Distance from airport: ${lead?.distanceFromAirport || "N/A"}`}
              </div>
              <div className="text-body d-block">
                {`Trans Provided: ${lead?.transferProvider ? "Yes" : "No"}`}
              </div>

              <div className="text-body d-block">
                {`Stay required: ${lead?.stayRequired ? "Yes" : "No"}`}
              </div>
              <div className="text-body d-block">
                {`Mode of transport: ${lead?.modeOfTransport || "N/A"}`}
              </div>
              <div className="text-body d-block">
                {`No of sites: ${lead?.numberOfSites || "N/A"}`}
              </div>
              <div className="text-body d-flex">
                Location link:
                {lead?.locationLink ? (
                  <a className=" ms-1" href={lead?.locationLink}>
                    visit link
                  </a>
                ) : (
                  " N/A"
                )}
              </div>
              <div className="text-body d-block">{formattedDate}</div>
              <div className="d-flex justify-content-left mt-2">
                {lead.lead_status === "site inspection schedule" && (
                  <button
                    className="btn btn-primary btn-sm me-2 px-2 py-1"
                    onClick={() => {
                      setSIInputData((prevData) => ({
                        dateofSI: lead?.dateofSI || "",
                        distanceFromAirport: lead?.distanceFromAirport || "",
                        locationLink: lead?.locationLink || "",
                        transferProvider: lead?.transferProvider || false,
                        numberOfSites: lead?.numberOfSites || "",
                        modeOfTransport: lead?.modeOfTransport || "",
                        stayRequired: lead?.stayRequired || false,
                      }));
                      setDataId(lead?.id);
                    }}
                    disabled={!isCardEnabled}
                  >
                    SI Details
                  </button>
                )}
                {lead?.lead_status === "software demo" && (
                  <a
                    className="btn btn-primary btn-sm me-2 px-2 py-1"
                    href="https://meet.google.com/landing"
                    disabled={!isCardEnabled}
                  >
                    Book demo
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadsTracking;
